import React from "react";
import { CiCircleInfo } from "react-icons/ci";
import { LuChevronDown } from "react-icons/lu";
import { TbBuildingBank } from "react-icons/tb";
export const Deposit = () => {
  return (
    <div>
      <div className="dark:bg-[#282828] bg-[#f0f0f0] p-6 rounded-xl">
        <div className="flex items-center space-x-2">
          <h2 className="text-2xl">Bank Account</h2>
          <p className="bg-[#5B5B5B] text-white w-fit px-[10px] py-[6px] rounded-lg">
            Inactive
          </p>
        </div>
        <div className="flex mt-3 items-center justify-between">
          <div className="flex items-center space-x-2">
            <label htmlFor="circle">IBAN</label>
            <CiCircleInfo className="text-[#1c1c1c] dark:text-white " />
          </div>
          <TbBuildingBank />
        </div>
     
        <input
          className="bg-white mt-3 dark:bg-[#1c1c1c] w-full px-4 py-3 rounded-lg"
          type="text"
          placeholder="Bank Account Number"
        />
        <button className="mt-3 bg-[#1c1c1c] text-white dark:bg-white dark:text-black px-4 py-3 rounded-lg">
          Submit
        </button>
      </div>

     
      <div className="my-4 bg-[#f0f0f0] dark:bg-[#282828]  rounded-lg p-6">
          <h1 className="text-[28px]">Account Type</h1>
        <p className="opacity-60">How do you want to sell? Select accordingly</p>
         
        <label htmlFor="name">First & Last</label>
        <br />
        <input
          className="bg-white dark:border-gray-600 dark:bg-[#1C1C1C] my-2 w-full  rounded-lg border px-4 py-3 bg-transparent"
          name="name"
          type="text"
          placeholder="John Doe"
        />
        <br />
        <div className="w-full  flex-col lg:flex-row flex items-center lg:space-x-2">
          <div className="relative w-full">
            <label htmlFor="Country">Country</label>
            <br />
            <select
              name="countries"
              className="custom-select bg-white dark:border-gray-600 dark:bg-[#1C1C1C] my-2 w-full rounded-lg border px-4 py-3 bg-transparent"
              id="countries"
            >
              <option value="Romania">Romania</option>
              <option value="Romania">Romania</option>
              <option value="Romania">Romania</option>
              <option value="Romania">Romania</option>
            </select>
            <LuChevronDown className='text-xl  absolute right-2 top-12'/>
          </div>
          <div className="w-full">
            <label htmlFor="City">City</label>
            <br />
            <input
              className="bg-white dark:border-gray-600 dark:bg-[#1C1C1C] my-2 w-full rounded-lg border px-4 py-3 bg-transparent"
              name="City"
              type="text"
              placeholder="Romania"
            />
          </div>
          <div className="w-full">
            <label htmlFor="Zip">Zip or Postal Code</label>
            <br />
            <input
              className="bg-white dark:border-gray-600 dark:bg-[#1C1C1C] my-2 w-full rounded-lg border px-4 py-3 bg-transparent"
              name="City"
              type="text"
              placeholder="Romania"
            />
          </div>
        </div>

      </div>
    </div>
  );
};
